export { default } from './SectionBadge';
export type { SectionBadgeProps } from './SectionBadge';
